module.exports = __webpack_public_path__ + "img/Asambleas.49fa9e9e.svg";